import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
// import {MainComponent} from 'src/app/feature/components/main/main.component';
import { NewLandingComponent } from './components/new-landing/new-landing.component';

const routes: Routes = [{
  path: '',
  component: NewLandingComponent,
  data: {revalidate: 60},
}, {
  path: 'coins',
  loadChildren: () => import('./modules/currency/currency.module').then(m => m.CurrencyModule)
}, {
  path: 'contact-us',
  loadChildren: () => import('./modules/contact-us/contact-us.module').then(m => m.ContactUsModule)
}, {
  path: 'coin',
  loadChildren: () => import('./modules/trade/trade.module').then(m => m.TradeModule)
}, {
  path: 'pages',
  loadChildren: () => import('./modules/dynamic-pages/dynamic-pages.module').then(m => m.DynamicPagesModule)
},
 {
  path: 'heatmap',
  loadChildren: () => import('./modules/heatmap/heatmap.module').then(m => m.HeatmapModule)
},
  {
  path: '**',
  loadChildren: () => import('./modules/not-found/not-found.module').then(m => m.NotFoundModule)
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FeatureRoutingModule {
}
